import React, { ChangeEvent, Dispatch, useEffect, useRef, useState } from 'react'

export type AreaType = {
    gnCode: string;
    area: string;
    areaName: string;
    adminLevelName: string;
}

type SpecificAreaTablePropsType = {
    data: AreaType[];
    handleSelectRow: (event: ChangeEvent<HTMLInputElement>, selected: AreaType) => void;
    selectedArea: string[];
}

const SpecificAreaTable = (props: SpecificAreaTablePropsType) => {
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const rowNumber = useRef<HTMLInputElement | null>(null)
    const searchText = useRef<HTMLInputElement | null>(null)

    const [selectedPage, setSelectedPage] = useState<number>(0)
    const [sliceCount, setSliceCount] = useState<number>(10)

    const [filteredData, setFilteredData] = useState<AreaType[]>([])
    const [slicedData, setSlicedData] = useState<AreaType[][]>([])

    const paginationList = (data: AreaType[], size: number): AreaType[][] => {
        const result: AreaType[][] = []
        
        if (size >= data.length) {
            return [data]
        }

        let start = 0

        while (start < data.length) {
            result.push(data.slice(start, start + size))
            start += size
        }

        return result
    }

    const paginationNavigation = (side: "next" | "prev") => {
        if (side === "next") {
            if (slicedData.length > selectedPage + 1) {
                setSelectedPage(prevState => prevState + 1)
                //console.log(">>>> good next")
            }
            
        } else if (side === "prev") {
            if (0 <= selectedPage - 1){
                setSelectedPage(prevState => prevState - 1)
            }
        }
    }

    // Handle slice count changed
    const handleSliceCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSliceCount(event.target.valueAsNumber)
    }

    // handle search text change
    const handleSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.trim().toLowerCase();
        if (event.target.value === '') {
            setFilteredData(props.data)
        } else {
            setFilteredData(prevState => prevState.filter(item => (item.gnCode?.toLowerCase()?.includes(value) ?? false)))
        }
    }

    useEffect(() => {
        setFilteredData(props.data)
    }, [props.data])
    

    useEffect(() => {
        if (rowNumber.current){
            setSlicedData(prevState => paginationList(filteredData, sliceCount))
        }
    }, [sliceCount, filteredData])

    return (
        <div className='subTable-wrapper'>
            <span className="main-title">Select specific area</span>
            <div className='field-wrapper'>
                <div className='left'>
                    <span>show <input type="number" ref={rowNumber} defaultValue={10} min={10} onChange={(e) => handleSliceCountChange(e)}/> entries</span>
                </div>
                <div className='right'>
                    <span> search <input type="text" ref={searchText} onChange={(e) => handleSearchTextChange(e)} placeholder='Search here'/></span>
                </div>
            </div>
            <div className='table-body'>
                <div className='table-wrapper'>
                    <div className='table-row header' style={{gridTemplateColumns: `3rem repeat(4, minmax(8rem, 1fr))`, width: '100%'}}>
                        <span></span>
                        <span>GN Code</span>
                        <span>Area</span>
                        <span>Area Name</span>
                        <span>Admin Level Name</span>
                    </div>
                </div>
                {slicedData[selectedPage] && slicedData[selectedPage].map((row, index) => (
                    <div key={index} className='table-wrapper'>
                        <div className='table-row' style={{gridTemplateColumns: `3rem repeat(4, minmax(8rem, 1fr))`, width: '100%'}}>
                            <span style={{justifyContent: 'center'}}>
                                <input type="checkbox" name={`${row.gnCode}`} onChange={(e) => props.handleSelectRow(e, row)} defaultChecked={props.selectedArea.includes(row.gnCode)}/>
                            </span>
                            <span>{row.gnCode}</span>
                            <span>{row.area}</span>
                            <span>{row.areaName}</span>
                            <span>{row.adminLevelName}</span>
                        </div>
                    </div>
                ))}
            </div>
            
            <div className='table-pagination-wrapper'>
                <div className='icon-page-box' style={{marginBottom: "0.5rem"}} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                <div className='page-wrapper'>
                    {slicedData.map((page, index) => (
                        <span key={index} className={selectedPage === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPage(index)}>{index + 1}</span>
                    ))}
                </div>
                <div className='icon-page-box' style={{marginBottom: "0.5rem"}} onClick={(e) => paginationNavigation("next")}>&gt;</div>
            </div>
        </div>
    )
}

export default SpecificAreaTable